import { stringToEnum } from '@snap-types/models/common';

export enum VisualScrapYieldType {
  SCRAP = 'S',
  YIELD = 'Y',
}

export const visualScrapYieldTypeSchema = stringToEnum(VisualScrapYieldType);

export enum VisualRunRateType {
  DAYS_PER_LOAD = 'DAYS/LOAD',
  HRS_PER_PC = 'HRS/PC',
  PCS_PER_MIN = 'PCS/MIN',
  HRS_PER_LOAD = 'HRS/LOAD',
  PCS_PER_HR = 'PCS/HR',
  PCS_PER_DAY = 'PCS/DAY',
  MIN_PER_PC = 'MIN/PC',
  DAYS_PER_PC = 'DAYS/PC',
  LOADS_PER_HR = 'LOADS/HR',
  LOADS_PER_DAY = 'LOADS/DAY',
}

export const visualRunRateTypeSchema = stringToEnum(VisualRunRateType);
